
import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
} from "reactstrap";

import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "../../utills/api";
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

const Login = () => {
  document.title = "HMS | Login";
  const navigate = useNavigate();

  const [passwordShow, setPasswordShow] = useState(false);
  const [loginType, setLoginType] = useState("admin"); // 🔥 admin | manager

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
      mobile: "",
    },

    validationSchema: Yup.object({
      email:
        loginType === "admin"
          ? Yup.string().required("Please Enter Your Email")
          : Yup.string(),

      password:
        loginType === "admin"
          ? Yup.string().required("Please Enter Your Password")
          : Yup.string(),

      mobile:
        loginType === "manager"
          ? Yup.string()
              .matches(/^[0-9]{10}$/, "Enter valid mobile number")
              .required("Mobile is required")
          : Yup.string(),
    }),

    onSubmit: async (values, { setSubmitting, setErrors, resetForm }) => {
      try {
        let res;

        // 🔥 API CALL BASED ON LOGIN TYPE
        if (loginType === "admin") {
          res = await axios.post("/auth/login", {
            email: values.email,
            password: values.password,
          });
        } else {
          res = await axios.post("/team-login/login", {
            mobile: values.mobile,
          });
        }

        const data = res.data;

    if (data.success && data.token) {

  const user = data.user || data.team || {};

  if (user.role === "Admin" && user.mustChangePassword) {
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(user));

  axios.defaults.headers.common.Authorization =
    `Bearer ${data.token}`;

  navigate("/change-password", { replace: true });
  return;
}

  // ✅ Save Auth
  localStorage.setItem("token", data.token);

  localStorage.setItem(
    "user",
    JSON.stringify(user)
  );

  sessionStorage.setItem(
    "authUser",
    JSON.stringify(user)
  );

  // ✅ Set axios default auth
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${data.token}`;

  // ✅ Set tenant
  if (user?.tenantId) {
    axios.defaults.headers.common[
      "X-Tenant-Id"
    ] = user.tenantId;
  }

  // ✅ Redirect by role
  if (user.role === "Admin") {

    navigate("/dashboard");

  } else if (user.role === "Manager") {

    if (user.department === "Housekeeping") {
      navigate("/crm-service-request");

    } else if (user.department === "Front-Office") {
      navigate("/crm-reservation");

    } else if (user.department === "F&B") {
      navigate("/crm-food-dine");

    } else if (user.department === "Spa") {
      navigate("/spa-dashboard");

    } else if (user.department === "Management") {
      navigate("/dashboard");

    } else {
      navigate("/dashboard");
    }

  } else {

    navigate("/dashboard");
  }
} else {
          setErrors({
            email: "Invalid credentials",
            mobile: "Invalid credentials",
          });
        }
      } catch (error) {
        console.error("Login error:", error);
        setErrors({
          email: "Invalid credentials",
          mobile: "Invalid credentials",
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content mt-lg-5">
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <Link to="/" className="d-inline-block auth-logo">
                    <img src={logoLight} alt="" height="40" />
                  </Link>
                  <p className="mt-3 fs-15 fw-medium">
                    Welcome to YatraNest:{" "}
                    <em>Where every stay feels effortless..</em>
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">

                    {/* 🔥 LOGIN TYPE TOGGLE */}
                    <div className="d-flex justify-content-center mb-3">
                      <Button
                        color={loginType === "admin" ? "primary" : "light"}
                        onClick={() => {
                          setLoginType("admin");
                          validation.resetForm();
                        }}
                        className="me-2"
                      >
                        Admin Login
                      </Button>

                      <Button
                        color={loginType === "manager" ? "primary" : "light"}
                        onClick={() => {
                          setLoginType("manager");
                          validation.resetForm();
                        }}
                      >
                        Manager Login
                      </Button>
                    </div>

                    <div className="text-center mt-2">
                      <h5 className="text-primary">Welcome Back!</h5>
                      <p className="text-muted">Sign in to continue</p>
                    </div>

                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                        }}
                      >

                        {/* ✅ ADMIN LOGIN */}
                        {loginType === "admin" && (
                          <>
                            <div className="mb-3">
                              <Label>Email</Label>
                              <Input
                                name="email"
                                placeholder="Enter Email"
                                value={validation.values.email}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                }
                              />
                              <FormFeedback>
                                {validation.errors.email}
                              </FormFeedback>
                            </div>

                            <div className="mb-3">
                              <Label>Password</Label>
                              <div className="position-relative">
                                <Input
                                  name="password"
                                  type={passwordShow ? "text" : "password"}
                                  placeholder="Enter Password"
                                  value={validation.values.password}
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  invalid={
                                    validation.touched.password &&
                                    validation.errors.password
                                  }
                                />
                                <button
                                  type="button"
                                  className="btn btn-link position-absolute end-0 top-0"
                                  onClick={() =>
                                    setPasswordShow(!passwordShow)
                                  }
                                >
                                  👁
                                </button>
                              </div>
                              <FormFeedback>
                                {validation.errors.password}
                              </FormFeedback>
                            </div>
                          </>
                        )}

                        {/* ✅ MANAGER LOGIN */}
                        {loginType === "manager" && (
                          <div className="mb-3">
                            <Label>Mobile Number</Label>
                            <Input
                              name="mobile"
                              placeholder="Enter Mobile Number"
                              value={validation.values.mobile}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.mobile &&
                                validation.errors.mobile
                              }
                            />
                            <FormFeedback>
                              {validation.errors.mobile}
                            </FormFeedback>
                          </div>
                        )}

                        <div className="mt-4">
                          <Button
                            color="secondary"
                            className="w-100"
                            type="submit"
                          >
                            Sign In
                          </Button>
                        </div>

                        <div className="mt-3 text-center">
                          <Link
                            to="/change-password"
                            className="fw-semibold text-primary text-decoration-underline"
                          >
                            Change Password
                          </Link>
                        </div>

                      </Form>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Login;